import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Api } from 'vl-common/src/api';
import type { Clinician } from 'vl-common/src/schemas/getCliniciansClinicians';

type UseClinicianListParams = {
  subtype?: string;
  specarea?: string;
  spec_cat?: string;
  patient_guid?: string;
  appt_type_code?: string;
  rank?: string;
  page?: number;
  gender: string;
  rows: number;
  name: string;
  case_id: number | null;
  tag_filter: boolean;
};

type ClinicianListResponse = { clinicians: Clinician[] };

type UseClinicianListOptions = {
  params: UseClinicianListParams;
} & Omit<UseQueryOptions<ClinicianListResponse, Error, Clinician[]>, 'queryKey' | 'queryFn' | 'select'>;

export const baseUseClinicianListQueryKey = ['cliniciansList'];

export const useClinicianList = ({ params, ...options }: UseClinicianListOptions) =>
  useQuery({
    queryKey: [...baseUseClinicianListQueryKey, params],
    queryFn: () => Api.clinicians.getAll(params) as Promise<ClinicianListResponse>,
    select: (data) => data?.clinicians || [],
    ...options
  });
